import xs from "xstream"
import isolate from "@cycle/isolate"
import * as R from "ramda"


import {num2FmtStr} from '../../../utils'
import {PAGE, STATE_KEY, MAGAZINE_URL} from '../../../constant'

import {pageViewTempl} from '../../common'
import {createApiReq, createApiResp} from '../../common'

import {view} from './view'
import sampleCombine from "xstream/extra/sampleCombine"

const photoReq = createApiReq("photo");
const photoResp = createApiResp("photo");

const memberIdFormat = num2FmtStr("0000000")

const PhotoUpload = sources => {
	const user$ = sources.state.select([STATE_KEY.User])
	// user$.addListener(dumper("USER"))
	const fileInput$ = sources.DOM.select('input[type="file"]').events("change")
		.map(R.path(["target", "files"]))

	const clearImage$ = fileInput$
		.filter(files => files.length === 0)
		.mapTo(null)
	
	const home$ = sources.DOM.select(".btnReturn2").events("click")
		.mapTo({ type: "goBack" })

	const loadedImage$ = xs.merge(sources.ImageLoader, clearImage$)
		.startWith(null)
		.remember()

	const loadResp$ = photoResp(sources.HTTP)
		.startWith(null)

	const view$ = view(loadedImage$, loadResp$)

	const initPush$ = xs.of(1).debug(() => window.scroll(0, 0))

	// const initReq$ = xs.of(pointsReq({}));

	const password$ = sources.DOM.select(".btnPassword2").events("click")
		.mapTo("/member/password")

	const logout$ = sources.DOM.select(".btnLogout2").events("click")
		.mapTo("/loading")

	const magazine$ = sources.DOM.select(".btnMagazine").events("click")
		.mapTo({href: MAGAZINE_URL, target: "_blank"})


	const loadImage$ = fileInput$
		.filter(files => files.length > 0)
		.map(R.nth(0))
		.map((file: any) => ({file}))

	const btnUpload$ = sources.DOM.select(".btnUpload").events("click")
		.compose(sampleCombine(user$, loadedImage$))
		.map(([_, user, loadedImage]) => {
			const src = R.prop("src", loadedImage)
			const photo = src.substr(src.indexOf(",") + 1)
			const data = {
				memberId: memberIdFormat(R.prop("id", user)),
				photo
			}
			return photoReq(data)
		})

	const loading$ = xs.merge(btnUpload$.mapTo(true), loadResp$.mapTo(false)).startWith(false)

	const pageView = pageViewTempl(PAGE.Top.id, xs.never(), "写真アップロード")
	return {
		HTTP: xs.merge(btnUpload$),
		DOM: pageView(view$),
		router: xs.merge(home$, password$, logout$),
		externalLink: xs.merge(magazine$),
		dumper: initPush$,
		ImageLoader: loadImage$,
		loading: loading$,
	}
}
export default isolate(PhotoUpload)
